/**
 * The seasonal picture behind an entry screen (see src/config/seasonConfig.ts).
 * Put it inside a wrapper whose class comes from seasonPageBackground(); renders nothing for the
 * heart look.
 */
import { SEASON_LOOK } from '@/config/seasonConfig'

export function SeasonBackdrop({ small = false }: { small?: boolean }) {
  if (SEASON_LOOK !== 'pumpkin') return null
  // small: a smaller pumpkin on wide screens (the welcome screen); phones are the same either way
  return <div className={`pumpkin-bg${small ? ' pumpkin-bg--small' : ''}`} aria-hidden="true" data-testid="season-backdrop" />
}
